/* eslint-disable default-param-last */
import { handle } from 'redux-pack';
import {
	LOAD_TELEPROMPTERS,
	REMOVE_TELEPROMPTER,
	SET_SELECTED_TELEPROMPTERS,
	UPDATE_SINGLE_TELEPROMPTER,
	UPDATE_TELEPROMPTER_SECTION,
} from '../actions/teleprompters';
import { TeleprompterInterface } from '../../types/interfaces';
import { decodeHtmlEntities } from '../../utils/utils';

interface Action {
	type: string;
	payload: any;
}

interface SelectedTeleprompters {
	[key: string]: number | null;
}

export interface TeleprompterReducerState {
	teleprompters: TeleprompterInterface[];
	loadingTeleprompters: boolean;
	telepromptersLoaded: boolean;
	selectedTeleprompters: SelectedTeleprompters;
}

export const initialState: TeleprompterReducerState = {
	teleprompters: [],
	loadingTeleprompters: false,
	telepromptersLoaded: false,
	selectedTeleprompters: {
		shot: null,
		media: null,
	},
};

const actions: Map<any, Function> = new Map([
	[LOAD_TELEPROMPTERS, (state: TeleprompterReducerState, action: Action) => handle(state, action, {
		start: (teleprompterState) => ({ ...teleprompterState, loadingTeleprompters: true }),
		finish: (teleprompterState) => ({ ...teleprompterState, loadingTeleprompters: false }),
		failure: (teleprompterState) => ({ ...teleprompterState, loadingTeleprompters: false }),
		success: (teleprompterState) => {
			const sanitizedPayload = decodeHtmlEntities(JSON.stringify(action.payload));
			return {
				...teleprompterState,
				teleprompters: JSON.parse(sanitizedPayload),
				telepromptersLoaded: true,
			};
		},
	})],
	[SET_SELECTED_TELEPROMPTERS, (state: TeleprompterReducerState, action: Action) => {
		const newSelectedTeleprompters = { ...state.selectedTeleprompters };
		// eslint-disable-next-line prefer-destructuring
		newSelectedTeleprompters[action.payload[0]] = action.payload[1];
		return {
			...state,
			selectedTeleprompters: newSelectedTeleprompters,
		};
	}],
	[UPDATE_SINGLE_TELEPROMPTER, (state: TeleprompterReducerState, action: Action) => {
		const newState = { ...state };

		let didExist = false;
		const teleprompters = newState.teleprompters.map((nTele: TeleprompterInterface) => {
			if (action.payload.id === nTele.id) {
				didExist = true;
				return action.payload;
			}
			return nTele;
		});

		if (!didExist) {
			teleprompters.unshift(action.payload);
		}
		newState.teleprompters = teleprompters;

		return newState;
	}],
	[UPDATE_TELEPROMPTER_SECTION, (state: TeleprompterReducerState, action: Action) => {
		const newState = { ...state };
		const teleprompters = newState.teleprompters.map((nTele: TeleprompterInterface) => {
			if (action.payload.teleprompterId === nTele.id) {
				let sectionExists = false;
				const newSections = nTele.sections.map((section: any) => {
					if (section.id === action.payload.section.id) {
						sectionExists = true;
						return action.payload.section;
					}
					return section;
				});
				if (!sectionExists) {
					newSections.push(action.payload.section);
				}
				return {
					...nTele,
					edited_date: new Date().valueOf(),
					sections: newSections,
				};
			}
			return nTele;
		});
		newState.teleprompters = teleprompters;
		return newState;
	}],
	[REMOVE_TELEPROMPTER, (state: TeleprompterReducerState, action: Action) => (
		{
			...state,
			teleprompters: state.teleprompters.filter((t) => t.id !== action.payload),
		}
	)],
]);

export function TeleprompterReducer(
	state: TeleprompterReducerState = initialState,
	action: Action,
) {
	return actions.get(action.type)?.(state, action) || state;
}
